export default __webpack_public_path__ + "static/media/no-course.1d219ac3.png";